export type BlockType = 'long' | 'long-mobile' | 'long-grid' | 'tile' | 'row' | 'plain' | 'feedback';

type PreviewHeightCalculatorOutPut = {
    height: number;
    width: number;
};

const previewHeightCalculator = (blockType: BlockType): PreviewHeightCalculatorOutPut => {
    let config = {
        height: 205,
        width: 145
    };

    if (blockType === 'long') {
        config = {
            height: 305,
            width: 212
        };
    }

    if (blockType === 'long-grid') {
        config = {
            height: 275,
            width: 195
        };
    }

    if (blockType === 'long-mobile') {
        config = {
            height: 142,
            width: 100
        };
    }

    if (blockType === 'tile') {
        config = {
            height: 280,
            width: 195
        };
    }

    if (blockType === 'feedback') {
        config = {
            height: 68,
            width: 48
        };
    }

    return config;
};

export default previewHeightCalculator;
